import React, { useState } from 'react';
import {
  Box,
  Button,
  Input,
  Text,
  VStack,
  Field,
  InputGroup,
  Icon,
  Image,
  Alert,
  PinInput,
  Span,
} from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router';
import { useFormik } from 'formik';
import BaseProgressCircle from '../../../../components/BaseProgressCircle';
import AuthCard from '../../components/AuthCard';
import { LOGIN } from "../../../../constants/routes";
import { ForgotPasswordData } from '../forgot-password/ForgotPasswordForm';

export interface VerifyRecoveryCodeData {
  email: string;
  code: string[];
}

interface VerifyRecoveryCodeFormProps {
  onVerifyRecoveryCodeSubmit: (formData: VerifyRecoveryCodeData, setError: (error: string) => void) => Promise<void>;
  resendCode: (formData: ForgotPasswordData, setError: (error: string) => void) => Promise<void>;
}

export default function VerifyRecoveryCodeForm ({ onVerifyRecoveryCodeSubmit, resendCode }: VerifyRecoveryCodeFormProps) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    values,
    handleChange,
    errors,
    touched,
    setFieldValue
  } = useFormik<VerifyRecoveryCodeData>({
    initialValues: {
      email: state?.email,
      code: ['','','',''],
    },
    onSubmit: async (formData) => {
      setLoading(true);
      await onVerifyRecoveryCodeSubmit(formData, setError);
      setLoading(false);
    },
  });


  return (
    <AuthCard title="Check your mailbox" onClose={() => navigate(LOGIN)}>
      <form onSubmit={handleSubmit}>
        <VStack align="stretch" gap={5}>
          <Text color="secondary">
            We have sent a verification code to your email
          </Text>


            <Field.Root invalid={touched.code && Boolean(errors.code)}>
              <InputGroup justifyContent={'center'}>
                <PinInput.Root value={values.code} onValueChange={(e: { value: string[]; }) => setFieldValue("code", e.value)}>
                    <PinInput.HiddenInput />
                    <PinInput.Control>
                        <PinInput.Input index={0} />
                        <PinInput.Input index={1} />
                        <PinInput.Input index={2} />
                        <PinInput.Input index={3} />
                    </PinInput.Control>
                </PinInput.Root>
              </InputGroup>

              <Field.ErrorText>{errors.code}</Field.ErrorText>
            </Field.Root>

            <Text color="secondary" fontSize={'sm'}>
                Did not receive the code?  <Span cursor="pointer" color='brand.solid' onClick={() => resendCode({email: state?.email}, setError)}>Resend code</Span>
            </Text>

          <Button 
            colorPalette="brand" 
            type="submit" 
            size='lg' 
            w='260px' 
            borderRadius={15} 
            alignSelf='center'
            // mt={8}
            disabled={loading || !values.code}
          >
            {loading ? <BaseProgressCircle /> : "Send"}
          </Button>

          {error && (
            <Alert.Root status="error">
              <Alert.Indicator />
              <Alert.Title>{error}</Alert.Title>
            </Alert.Root>
          )}
        </VStack>
      </form>
    </AuthCard>
  );
};
